class Filter {
    constructor() {

        // Declare variables
        this.pairs = {};

        // Call init methods
        this._setDOMReferences();
    }

    filter(aID) {
        var e = document.getElementById(aID);
        var val = e.options[e.selectedIndex].value;
        var group = e.getAttribute('data-filtergroup');

        if (val) {
            this.setState(group, aID, 'passive');
        }

        const elements = this.pairs[aID].targets.concat(this.pairs[aID].togglers);

        elements.forEach((aElement) => {
            if (aElement.getAttribute('data-role') == 'target' && aElement.getAttribute('data-filtervalue') != val) {
                aElement.setAttribute('data-state', 'passive');
            } else {
                aElement.setAttribute('data-state', 'active');
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    setState(group, current, state) {
        var elements = document.querySelectorAll('*[data-filtergroup="' + group + '"]');
        elements.forEach((element) => {
            element.setAttribute('data-state', state);

            if (state == 'passive' && element.getAttribute('data-filterid') != current && element.getAttribute('data-role') == 'toggler') {
                element.value = '';
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    resetState(group) {
        var elements = document.querySelectorAll('*[data-filtergroup="' + group + '"]');
        elements.forEach((element) => {
            if (element.getAttribute('data-role') == 'toggler') {
                element.value = '';
                element.setAttribute('data-state', 'passive');
            } else if (element.getAttribute('data-role') == 'target') {
                element.setAttribute('data-state', 'active');
            }
        });
    }

    _setDOMReferences() {
        // Build an array with all toggle-id's
        const elements = document.querySelectorAll('[data-filterid]');
        elements.forEach((aElement) => {

            // Push a new entry if none exists yet for the id
            const id = aElement.getAttribute('data-filterid');
            if (!this.pairs[id]) {
                this.pairs[id] = {
                    togglers: [],
                    targets: []
                };
            }

            // Push the togglers and target elements to their relative pair
            let role = aElement.getAttribute('data-role');
            if (role == 'toggler') {
                aElement.addEventListener('change', () => {
                    this.filter(id);
                });
                this.pairs[id].togglers.push(aElement);
            } else if (role == 'target') {
                this.pairs[id].targets.push(aElement);
            }
        });

        const resetlinks = document.querySelectorAll('.js--filter-reset');
        resetlinks.forEach((link) => {

            const group = link.getAttribute('data-filtergroup');
            link.addEventListener('click', () => {
                this.resetState(group);
            });
        });

        // After setup check for url params
        const params = {};
        const paramsStringArray = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        paramsStringArray.forEach(paramString => {
            const hash = paramString.split('=');
            params[hash[0]] = hash[1];
        })
        if (params['product-category'] && params['category']) {
            const select = document.getElementById(`category-${params['product-category']}`);
            if (select) {
                select.value = params['category'];
                select.dispatchEvent(new Event('change'));
            }
        }
    }

}

export default Filter;